module.exports = __webpack_public_path__ + "img/Logo_nova.98f30194.png";